import { Component, Inject, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { take } from 'rxjs/operators';
import { AnessaTranslationService } from '../../../../../helper/translation/anessa-translation.service';
import { DeactivationDialogService } from '../../../../../helper/can-deactivate/deactivation-dialog.service';
import { ProjectChecklistRow } from '../../../../../models/project/project-info.model';
import { UserpilotReloader } from '../../../../../helper/userpilot-reloader.component';

@Component({
  selector: 'app-edit-row-dialog',
  templateUrl: './edit-row-dialog.component.html',
  styleUrls: [
    './edit-row-dialog.component.scss',
  ]
})
export class EditRowDialogComponent extends UserpilotReloader {

  @ViewChild('rowForm') form: NgForm;

  trigger: string;
  newItemName: string;

  row: ProjectChecklistRow;

  isEdit = false;
  showClearName = false;
  showClearMin = false;
  showClearMax = false;
  showClearFlag = false;

  constructor(
    private dialogRef: MatDialogRef<EditRowDialogComponent>,
    private deactivationDialogService: DeactivationDialogService,
    private translationService: AnessaTranslationService,
    @Inject(MAT_DIALOG_DATA) private data: { row: ProjectChecklistRow },
  ) {
    super();
    if (this.data.row != null) {
      this.isEdit = true;
      this.row = this.data.row;
    } else {
      this.row = new ProjectChecklistRow();
    }

    this.trigger = this.translationService.getCurrentLang();

    this.dialogRef.backdropClick().subscribe(() => {
      if (this.form.dirty) {
        this.deactivationDialogService.confirm(this.translationService.get('PROJECT.COMMON.DEACTIVATE_CONFIRM'))
          .pipe(take(1)).subscribe(result => {
            if (result) {
              this.dialogRef.close();
            }
          });
      } else {
        this.dialogRef.close();
      }
    });
  }

  onSave() {
    this.dialogRef.close(this.row);
  }

  onCancel() {
    this.dialogRef.close();
  }

  addLogic() {
    // TODO
  }
}
